module.exports = __webpack_public_path__ + "static/media/play.dad8b18d.svg";